// extracted by mini-css-extract-plugin
export default {"project_container":"Projects_project_container__TyD91","title_container":"Projects_title_container__jwEpr"};